import { AxiosResponse } from 'axios';
import objLetters from './objLetters';

const { deepLowercaseObj, shallowLowercaseObj } = objLetters;

const lowercaseResData = (deep: boolean) => <T>(
  res: AxiosResponse<T>
): AxiosResponse<T> => ({
  ...res,
  data: deep ? deepLowercaseObj(res.data) : shallowLowercaseObj(res.data)
});

const deepLowercaseResData = lowercaseResData(true);
const shallowLowercaseResData = lowercaseResData(false);

export default { deepLowercaseResData, shallowLowercaseResData };
